import React, { useState, useRef, useEffect } from "react";
import styles from "./projects.module.scss";
import Project from "./Project";
// import itaImg from "../../assets/images/dev-icon.jpg";
import parodyImg from "../../assets/images/parody.jpg";
import big3Img from "../../assets/images/big3 prev.jpg";
import edtImg from "../../assets/images/edt.png";
import certgoImg from "../../assets/images/certgo.png";
import basicImg from "../../assets/images/basic.png";
import waxelyImg from "../../assets/images/waxely.png";

const Projects = () => {
  const domRef: any = useRef();
  const [isVisible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const currentEl = domRef.current;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        // console.log("intersecting", isVisible)
        return setVisible(e.isIntersecting);
      });
    });
    observer.observe(domRef.current);
    if (currentEl) {
      return () => observer.unobserve(currentEl);
    }
  }, []);
  return (
    <section
      className={`${styles.projects} ${isVisible ? styles.isVisible : null}`}
      id="projects"
      ref={domRef}
    >
      <h2>My Projects</h2>
      <div className={styles.container}>
        <Project
          liveLink="https://app.waxely.com"
          stacks={["ReactJs", "NestJs", "PostgreSQL", "AWS", "Docker"]}
          codeLink="#"
          name="Waxely"
          image={waxelyImg}
          description="A smart, guided tax calculation and compliance platform built to simplify tax preparation for individuals, freelancers, and businesses. It features automated deduction matching, step-by-step calculations, and a customized portal sync guide to ensure accurate filings and zero penalties."
        />
        <Project
          liveLink="https://certgo.app"
          stacks={["Javascript", "Nodejs", "react"]}
          codeLink="#"
          name="CertGo"
          image={certgoImg}
          description="A certificate generator App"
        />

        <Project
          liveLink="https://basic-agency-bobola.netlify.app/"
          stacks={["Typescript", "react"]}
          codeLink="https://github.com/Adebobola01/basic-agency-clone"
          name="Basic Agency"
          image={basicImg}
          description="A UI clone of the basic agency home page."
        />

        <Project
          name="Uniswap Parody"
          image={parodyImg}
          description="A UI clone of the swapping protocol uniswap"
          stacks={["React", "Typescript", "SCSS"]}
          codeLink="https://github.com/Adebobola01/uniswap-parody"
          liveLink="https://uniswap-parody.vercel.app/"
        />
        <Project
          name="big3 Marketplace"
          image={big3Img}
          description="A NFT marketPlace."
          stacks={["React", "Typescript", "SCSS"]}
          codeLink="https://github.com/Adebobola01/big3-react"
          liveLink="https://big3.onrender.com/"
        />
        <Project
          liveLink="https://jounal-app.vercel.app/"
          stacks={["Typescript", "Nodejs"]}
          codeLink="https://github.com/EDT-JOURNAL/journal-server"
          name="EDT Journal"
          image={edtImg}
          description="A bloging website"
        />
      </div>
    </section>
  );
};

export default Projects;
